<template>
  <Card>
    <div v-if="org.attributes.underReview">
      <AsyncImage
        class="w-64 mx-auto"
        :src="getAbsoluteAssetLink('nami/stickers/no_search_results.png')"
      />
      <h3 class="font-medium text-center my-4 text-xl">
        Creator under review.
      </h3>
      <p class="text-center text-sm">
        Our team is currently reviewing this profile.
      </p>
      <p class="text-center text-sm">
        Please check back later and enjoy comics from our
        <NamiLink :to="`/${$route.params.locale}/discover`">
          community of creators
        </NamiLink>
        in the meantime.
      </p>
    </div>
    <ClientOnly v-else>
      <OrganizationSubscribeForm
        :org-slug="org.attributes.slug"
        :orgId="org.id"
        :disabled="org.attributes.underReview"
        :orgName="orgName"
        :highlightTierId="highlightTier ?? undefined"
        :highlightText="highlightText ?? undefined"
      />
    </ClientOnly>
  </Card>
</template>

<script setup lang="ts">
import type { OrganizationEntity } from "~/src/api";

defineProps<{
  org: OrganizationEntity;
  orgName?: string;
}>();

const { highlightTier, highlightText } = useRouteQueryTemplate({
  highlightTier: {
    type: "string.nullable",
    default: null,
  },
  highlightText: {
    type: "string.nullable",
    default: null,
  },
});
</script>
